import app from 'flarum/forum/app';
import FieldSet from 'flarum/common/components/FieldSet';
import Icon from 'flarum/common/components/Icon';
import ItemList from 'flarum/common/utils/ItemList';
import humanTime from 'flarum/common/utils/humanTime';
import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import UserPage from 'flarum/forum/components/UserPage';
const m = window.m;
function viewerAvatar(viewer) {
  if (!viewer) {
    return m('img.Avatar', {
      src: '/bilder/guest.png',
      alt: ''
    });
  }
  if (viewer.avatarUrl) {
    return m('img.Avatar', {
      src: viewer.avatarUrl,
      alt: viewer.displayName || viewer.username || ''
    });
  }
  const name = viewer.displayName || viewer.username || '?';
  return m('span.Avatar', {
    title: name
  }, name.trim().charAt(0).toUpperCase());
}
function viewerItem(profileView, index) {
  const viewer = profileView.viewer || null;
  const visitedAt = profileView.visitedAt ? new Date(profileView.visitedAt) : null;
  const content = m('div.item-lastUser-content', [viewerAvatar(viewer), m('div', [viewer ? viewer.displayName || viewer.username : app.translator.trans('michaelbelgium-flarum-profile-views.forum.user.viewlist.guest'), visitedAt ? m('span.lastUser-visited', {
    title: visitedAt.toLocaleString()
  }, humanTime(visitedAt)) : null])]);
  if (viewer && viewer.username) {
    return m('a', {
      href: app.route('user', {
        username: viewer.username
      })
    }, content);
  }
  return content;
}
app.initializers.add('kojonos-profile-views', () => {
  extend(UserCard.prototype, 'infoItems', function (items) {
    const user = this.attrs.user;
    const count = user.attribute('profileViewCount');
    if (count === undefined || count === null) {
      return;
    }
    items.add('profile-views', m('span', [m(Icon, {
      name: 'far fa-eye'
    }), ' ', app.translator.trans('michaelbelgium-flarum-profile-views.forum.user.view_count_text', {
      viewcount: Number(count) || 0
    })]));
  });
  extend(UserPage.prototype, 'sidebarItems', function (items) {
    if (!this.user) {
      return;
    }
    const views = this.user.attribute('latestProfileViews');
    if (!Array.isArray(views)) {
      return;
    }
    const lastViewed = new ItemList();
    views.forEach((profileView, index) => {
      lastViewed.add(`lastUser-${index}`, viewerItem(profileView, index));
    });
    items.add('lastViewedUsers', m(FieldSet, {
      label: app.translator.trans('michaelbelgium-flarum-profile-views.forum.user.viewlist.title'),
      className: 'LastUsers'
    }, lastViewed.toArray()));
  });
  extend(UserPage.prototype, 'show', function () {
    if (!this.user) {
      return;
    }
    const user = this.user;
    const recordView = () => {
      app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/profileview`,
        body: {
          viewedUser: user.id()
        }
      }).catch(() => {
        // Eigenes Profil oder deaktiviertes Gäste-Tracking.
      });
    };
    if (user.attribute('latestProfileViews') === undefined) {
      app.store.find('users', user.id(), {
        profileViewsRefresh: Date.now()
      }).then(() => {
        m.redraw();
        recordView();
      }).catch(() => {});
    } else {
      recordView();
    }
  });
});